import { render } from "./menudigital.vue?vue&type=template&id=5ac7f449"
import script from "./menudigital.vue?vue&type=script&lang=js"
export * from "./menudigital.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/mixitweb-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__